/** Vertical padding for Spartan product page sections (and product-used shared). */
export const SPARTAN_PRODUCT_SECTION_CLASS_NAME =
  'py-7 xs:py-10 md:py-14 lg:py-16';

/** Top-only padding matching `SPARTAN_PRODUCT_SECTION_CLASS_NAME`. */
export const SPARTAN_PRODUCT_SECTION_PT_CLASS_NAME =
  'pt-7 xs:pt-10 md:pt-14 lg:pt-16';

/** Bottom-only padding matching `SPARTAN_PRODUCT_SECTION_CLASS_NAME`. */
export const SPARTAN_PRODUCT_SECTION_PB_CLASS_NAME =
  'pb-7 xs:pb-10 md:pb-14 lg:pb-16';
